import {callAPI} from '@/store/utils';
import {markRaw} from 'vue';
const FYGR_COMPANY = 'FYGR_COMPANY';

export default {
  namespaced: true,
  state: {
    reports: [],
    companyId: localStorage.getItem(FYGR_COMPANY),
    dashboardDataFlatten: [],
    compareDataFlatten: [],
    report: {
      id: '',
      name: 'reportname',
      indicators: [],
    },
    indicator: {
      id: '',
      name: '',
      color: '#30CE8F',
      status: true,
      isTechnical: false,
      comment: '',
      formula: '',
      reportId: '',
    },
    //TODO add description in French to better understandin'
    cashValues: markRaw([
      {
        name: 'Solde bancaire (début de période)',
        value: "VAL('@system-begin')",
        description: 'Solde bancaire (début de période)',
        formula: "VAL('begin')",
      },
      {
        name: 'Entrées',
        value: "VAL('@system-income')",
        icon: 'fi fi-income entree-svg',
        description: 'Entrées',
        formula: "VAL('@system-income')",
      },
      {
        name: 'Sorties',
        value: "VAL('@system-expense')",
        icon: 'fi fi-expenses sortie-svg',
        description: 'Sorties',
        formula: "VAL('expense')",
      },
      {
        name: 'Variation',
        value: "VAL('@system-variation')",
        icon: 'fi fi-delta',
        description: 'Variation',
        formula: "VAL('variation')",
      },
      {
        name: 'Solde bancaire (fin de période)',
        value: "VAL('@system-end')",
        description: 'Solde bancaire (fin de période)',
        formula: "VAL('end')",
      },
    ]),
    operators: markRaw([
      {
        name: '*',
        value: '*',
        description: 'Multiplication',
        formula: 'ex. : 4 * 3 = 12',
      },
      {
        name: '+',
        value: '+',
        description: 'Addition',
        formula: 'ex. : 2 + 3 = 5',
      },
      {
        name: '-',
        value: '-',
        description: 'Soustraction',
        formula: 'ex. : 7 - 2 = 5',
      },
      {
        name: '/',
        value: '/',
        description: 'Division',
        formula: 'ex. : 10 / 2 = 5',
      },
      {
        name: '%',
        value: '%',
        description: 'Modulo — reste de la division',
        formula: 'ex. : 10 % 3 = 1',
      },

      {
        name: 'AVGS(path)',
        value: 'AVGS()',
        description: 'Moyenne de toutes les valeurs de path.',
        formula: 'ex. : AVGS("Recettes") ≈ 4.33',
      },
      {
        name: 'ET(...args)',
        value: 'ET()',
        description: 'ET logique sur tous les arguments.',
        formula: 'ex. : ET(true, 1 < 2, 5) = true',
      },

      {
        name: 'GET(arr, idx)',
        value: 'GET()',
        description: 'Élément à l’indice idx (supporte les indices négatifs).',
        formula: 'ex. : GET([10, 20, 30], -1) = 30',
      },
      {
        name: 'LEN(arr)',
        value: 'LEN()',
        description: 'Longueur du tableau.',
        formula: 'ex. : LEN([7, 8, 9]) = 3',
      },
      {
        name: 'MAX(...args)',
        value: 'MAX()',
        description: 'Renvoie le maximum.',
        formula: 'ex. : MAX(3, 7, 2) = 7',
      },
      {
        name: 'MAXV(path)',
        value: 'MAXV()',
        description: 'Maximum sur toutes les valeurs de path.',
        formula: 'ex. : MAXV("Recettes") = 7',
      },
      {
        name: 'MEDIAN(path)',
        value: 'MEDIAN()',
        description: 'Médiane des valeurs de path.',
        formula: 'ex. : MEDIAN("Recettes") = 4',
      },
      {
        name: 'MIN(...args)',
        value: 'MIN()',
        description: 'Renvoie le minimum.',
        formula: 'ex. : MIN(3, 7, 2) = 2',
      },
      {
        name: 'MINV(path)',
        value: 'MINV()',
        description: 'Minimum sur toutes les valeurs de path.',
        formula: 'ex. : MINV("Recettes") = 2',
      },
      /*
      {
        name: 'NEXT(k?)',
        value: 'NEXT()',
        description: 'Valeur suivante dans la série primaire (k par défaut 1).',
        formula: 'ex. : NEXT()  → valeur à i+1 ; NEXT(2) → i+2',
      },
      */
      {
        name: 'OU(...args)',
        value: 'OU()',
        description: 'OU logique sur tous les arguments.',
        formula: 'ex. : OU(false, 0, "x") = true',
      },
      /*
      {
        name: 'PREV(k?)',
        value: 'PREV()',
        description:
          'Valeur précédente dans la série primaire (k par défaut 1).',
        formula: 'ex. : PREV()  → valeur à i-1 ; PREV(2) → i-2',
      },
      */
      {
        name: 'RANGE(start, end, step?)',
        value: 'RANGE()',
        description: 'Génère une suite entre start et end, pas step.',
        formula: 'ex. : RANGE(1, 5) = [1, 2, 3, 4, 5]',
      },
      {
        name: 'SAFE_DIV(num, den, fallback?)',
        value: 'SAFE_DIV()',
        description: 'Division sûre : fallback si den=0/NaN/infini.',
        formula: 'ex. : SAFE_DIV(10, 0, 0) = 0',
      },
      {
        name: 'SI(cond, a, b)',
        value: 'SI()',
        description: 'Retourne a si cond est vrai, sinon b.',
        formula: 'ex. : SI(3 > 2, 10, 0) = 10',
      },
      {
        name: 'SUM(...args)',
        value: 'SUM()',
        description: 'Somme des arguments.',
        formula: 'ex. : SUM(3, 7, 2) = 12',
      },
      {
        name: 'SUMS(path)',
        value: 'SUMS()',
        description: 'Somme de toutes les valeurs de path.',
        formula: 'ex. : SUMS("Recettes") = 13',
      },
      {
        name: 'CUMSUM(path)',
        value: 'CUMSUM()',
        description:
          'Somme cumulée des valeurs de la série, retournée sous forme de tableau.',
        formula: 'ex. : CUMSUM([1,2,3]) = [1,3,6]',
      },
      /*
      {
        name: 'UNIQUE(arr)',
        value: 'UNIQUE()',
        description: 'Supprime les doublons (garde le premier).',
        formula: 'ex. : UNIQUE([1, 1, 2, 2, 3]) = [1, 2, 3]',
      },
      */
      {
        name: 'VAL(path, offset?, fallback?)',
        value: 'VAL()',
        description:
          'Valeur à l’index courant (i - offset) de path (en calcul par élément).',
        formula:
          'ex. : VAL("Recettes")  → valeur à i ; VAL("Recettes", 1)  → valeur à i-1',
      },
      {
        name: 'VALUES(path)',
        value: 'VALUES()',
        description:
          'Renvoie toutes les valeurs d’une catégorie (par label ou id).',
        formula: 'ex. : VALUES("Recettes") = [2, 4, 7]',
      },
    ]),
  },
  mutations: {
    setReports(state, data) {
      state.reports = data;
    },
    setDashboardData(state, data) {
      state.dashboardDataFlatten = data;
    },
    setCompareData(state, data) {
      state.compareDataFlatten = data;
    },
    editIndicator(state, data) {
      const report = state.reports.find((item) => item.id === data.id);
      if (report && report.indicators) {
        let indicatorIndx = report.indicators.findIndex(
          (item) => item.id === data.indicator.id,
        );
        report.indicators[indicatorIndx] = {...data.indicator};
      }
    },
    deleteIndicator(state, data) {
      const report = state.reports.find((item) => item.id === data.id);
      if (report && report.indicators) {
        let indicatorIndx = report.indicators.findIndex(
          (item) => item.id === data.indicator.id,
        );
        report.indicators.splice(indicatorIndx, 1);
      }
    },
  },
  getters: {
    reports(state) {
      return state.reports && state.reports.length ? state.reports : [];
    },
    allIndicators(state) {
      return state.reports && state.reports.length
        ? state.reports.flatMap((report) => report.indicators)
        : [];
    },
  },
  actions: {
    async actionGetReports({commit, state}) {
      const res = await callAPI('GET', `company/${state.companyId}/report`);
      commit('setReports', res?.result);
      return res.result;
    },
    async addIndicatorToReport({commit, state, dispatch}, data) {
      const res = await callAPI(
        'POST',
        `company/${state.companyId}/indicator`,
        {
          ...data,
        },
      );
      await dispatch('actionGetReports');
      return res.result;
    },
    async actionEditIndicatorReport({commit, state, dispatch}, data) {
      const res = await callAPI(
        'PUT',
        `company/${state.companyId}/indicator/${data.id}`,
        {
          ...data,
        },
      );
      await dispatch('actionGetReports');
      return res.result;
    },
    async actionDeleteIndicatorToReport({commit, state, dispatch}, data) {
      await callAPI(
        'DELETE',
        `company/${state.companyId}/indicator/${data.indicator_id}`,
        {
          ...data,
        },
      );
      await dispatch('actionGetReports');
    },
    async actionDeleteReport({commit, state, dispatch}, id) {
      const res = await callAPI(
        'DELETE',
        `company/${state.companyId}/report/${id}`,
      );
      await dispatch('actionGetReports');
      return res;
    },
    async actionEditReport({commit, state, dispatch}, data) {
      const res = await callAPI(
        'PUT',
        `company/${state.companyId}/report/${data.id}`,
        {
          ...data,
        },
      );
      await dispatch('actionGetReports');
      return res.result;
    },
    async actionCreateNewReport({commit, state, dispatch}, data) {
      const res = await callAPI('POST', `company/${state.companyId}/report`, {
        ...data,
      });
      await dispatch('actionGetReports');
      return res.result;
    },
  },
};
